export function EllipsisCell({ textValue }: { textValue: string; }) {
  return <div title={textValue} style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{textValue}</div>;
}
